import { BehaviorSubject } from 'rxjs';

// public sub
export const basicListener = new BehaviorSubject<Record<string, any>>({
  action: null,
});

// private publicator
export const basicChannel = {
  send: msg => {
    basicListener.next({
      ...basicListener.value,
      ...msg,
    });
  },
  clear: () => {
    basicListener.next({
      action: null,
    });
  },
};
